import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Mascot } from "./Mascot";
import { useMascotLook } from "./useMascotLook";
import { useFinancialMascot } from "./useFinancialMascot";
import { cn } from "@/lib/cn";
import styles from "./FloatingMascot.module.css";

/**
 * Mascote fixo no canto inferior direito, presente em todo o app logado. Clicar nele
 * mostra um balão com uma mensagem sorteada de um baú com dezenas de frases — algumas com
 * dados de verdade da conta (categoria que mais pesa, maior gasto do mês, sequência de
 * dias anotando, dia do mês que mais pesou...), outras com dicas gerais de educação
 * financeira. Sorteia de novo a cada clique, então não é sempre a mesma. O humor do
 * mascote reflete o saldo/economia reais.
 */
export function FloatingMascot() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const { ref: wrapRef, look } = useMascotLook();
  const { mood, pickMessage } = useFinancialMascot();

  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open, wrapRef]);

  const toggle = () => {
    setOpen((v) => {
      const next = !v;
      if (next) setMessage(pickMessage());
      return next;
    });
  };

  return (
    <div className={styles.wrap} ref={wrapRef}>
      {open && (
        <div className={styles.bubble} role="dialog">
          <button type="button" className={styles.closeButton} onClick={() => setOpen(false)} aria-label="Fechar">
            <X size={13} strokeWidth={2.5} />
          </button>
          <p className={styles.bubbleText}>{message}</p>
        </div>
      )}
      <button type="button" className={styles.button} onClick={toggle} aria-label="Ver insights das suas finanças">
        <Mascot mood={mood} look={look} size={58} />
      </button>
    </div>
  );
}
